import { Injectable } from '@angular/core';
import { transaction } from '@datorama/akita';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { IOrganizationUnitDetails } from 'typings/doenkids/doenkids';
import { OrganizationUnitCustomerDetailsStore } from './organization-unit-customer-details.store';
import { firstValueFrom } from 'rxjs';

export type IOrganizationUnitCustomerDetails = Pick<
  IOrganizationUnitDetails,
  'address' | 'postalcode' | 'city' | 'billing_address' | 'billing_postalcode' | 'billing_city' | 'phone_number' | 'email' | 'kostenplaats' | 'lrk_identifier'
>;

export type IOrganizationUnitCustomerDetailsEditable = Pick<
  IOrganizationUnitDetails,
  'address' | 'postalcode' | 'city' | 'billing_address' | 'billing_postalcode' | 'billing_city' | 'phone_number' | 'email' | 'kostenplaats'
>;

export interface IUpdateLrkIdentifierRequest {
  lrk_identifier: string | null;
}

@Injectable({ providedIn: 'root' })
export class OrganizationUnitCustomerDetailsService {
  constructor(private $baseApi: DoenKidsGenericApiProvider, private store: OrganizationUnitCustomerDetailsStore) {}

  @transaction()
  async fetch(organizationUnitId: number): Promise<IOrganizationUnitCustomerDetails> {
    const response = (await firstValueFrom(
      this.$baseApi.genericGetCall(`/customer/organization-unit-customer-details/${organizationUnitId}/customer-details`),
    )) as IOrganizationUnitCustomerDetails;

    this.store.update(response);
    return response;
  }

  @transaction()
  async update(
    organizationUnitId: number,
    customerDetails: IOrganizationUnitCustomerDetailsEditable,
  ): Promise<IOrganizationUnitCustomerDetails> {
    const response = (await firstValueFrom(
      this.$baseApi.genericPutCall(`/customer/organization-unit-customer-details/${organizationUnitId}/details`, customerDetails),
    )) as IOrganizationUnitCustomerDetails;

    this.store.update(response);
    return response;
  }

  /**
   * Update LRK identifier for an organization unit via the customer-details API
   */
  async updateLrkIdentifier(
    organizationUnitId: number,
    payload: IUpdateLrkIdentifierRequest,
  ): Promise<void> {
    await firstValueFrom(
      this.$baseApi.genericPutCall(`/customer/organization-unit-customer-details/${organizationUnitId}/lrk-identifier`, payload),
    );
  }
}
